import { connectStepper } from "../util/redux";
import OneBack from "../components/one-back";

export default connectStepper(OneBack);
